import React from 'react';
import {Container, NavDropdown, Nav, Navbar, Form, FormControl,Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../stylesheets/navbar.css"
import "../js/main.js"



const Navbar2 = () => {
  

    $(document).ready(function () {
            $('#sidebarCollapse').on('click', function () {
                $('#sidebar').toggleClass('active');
            });
        });
return(


        <nav id="sidebar">
            <div class="sidebar-header">
            <img className="headerlogo" src="images/logo.png"/>
            </div>

            <ul class="list-unstyled components">
          
                <li class="active webapplink">
                    <a href="/home" data-toggle="collapse" aria-expanded="false" class=""><img src="./images/webapp/icons/home.png"/> Home</a>
                    {/* <ul class="collapse list-unstyled" id="homeSubmenu">
                        <li>
                            <a href="#">Home</a>
                        </li>
                        <li>
                            <a href="#">Account</a>
                        </li>
                        <li>
                            <a href="#">Order</a>
                        </li>
                        <li>
                            <a href="#">History</a>
                        </li>
                    </ul> */}
                </li>
                <li>
                    <a href="#"><img src="./images/webapp/icons/account.png"/> Account</a>
                </li>


                {/* <li>
                    <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Pages</a>
                    <ul class="collapse list-unstyled" id="pageSubmenu">
                        <li>
                            <a href="#">Page 1</a>
                        </li>
                        <li>
                            <a href="#">Page 2</a>
                        </li>
                        <li>
                            <a href="#">Page 3</a>
                        </li>
                    </ul>
                </li> */}


                <li>
                    <a href="#"><img src="./images/webapp/icons/order.png"/>  Order</a>
                </li>
                <li>
                    <a href="#"><img src="./images/webapp/icons/history.png"/>  History</a>
                </li>
            </ul>

            <ul class="list-unstyled CTAs">
            <li>
                    <a href="#"><img src="./images/webapp/icons/settings.png"/>   Settings</a>
                </li>
                <li>
                    <a href="/signin"><img src="./images/webapp/icons/logout.png"/> Log out</a>
                </li>
            </ul>
        </nav>


  
)

};


export default Navbar2;